/* eslint-disable no-extend-native */
import { getAllInsightTypes, groupInit, priorityInit, statusInit, tagInit } from "@redux/index";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { PageTemplate } from "shared/global-layouts/PageTemplate";
import { FlexColumnGap } from "shared/ui-basics/index";
import { TaxonomyMenuCard } from "../components/TaxonomyMenuCard";
import DataLoader from "shared/components/data-loader";

const Taxonomy = () => {
	return (
		<DataLoader  reduxActions={[statusInit,priorityInit, groupInit, tagInit, getAllInsightTypes]}>
			<LoadedTaxonomyPage />
		</DataLoader>
	);
};

const LoadedTaxonomyPage = () => {
	const { t } = useTranslation();

	const subscriptionPlan = useSelector((state) => state.auth?.userInfo?.UserSubscriptionPlanName);
	const isStandard = subscriptionPlan === "Standard";
	const librariesData = useSelector((state) => state?.libraries);

	const menuData = [
		{
			name: t("ASPX_222"),
			description: t("STATUS_DESCRIPTION"),
			url: "status",
			icon: "circle",
			nRecords: librariesData?.status ? Object.values(librariesData?.status).reduce((sum, array) => sum + array.length, 0) : 0,
		},
		{
			name: t("PRIORITY"),
			description: t("PRIORITY_DESCRIPTION"),
			url: "priority",
			icon: "arrow-up-big-small",
			nRecords: librariesData?.priority ? Object.values(librariesData?.priority).reduce((sum, array) => sum + array.length, 0) : 0,
		},
		{
			name: t("GROUP"),
			description: t("GROUP_DESCRIPTION"),
			url: "group",
			icon: "users",
			nRecords: librariesData?.group ? librariesData?.group?.length : 0,
		},
		{
			name: t("TAG"),
			description: t("TAG_DESCRIPTION"),
			url: "tag",
			icon: "tag",
			nRecords: librariesData?.tags ? librariesData?.tags?.length : 0,
		},
		{
			name: t("INSIGHT_TYPE"),
			description: t("INSIGHT_TYPE_DESCRIPTION"),
			url: "insight-type",
			icon: "hashtag",
			nRecords: librariesData?.insightTypes ? librariesData?.insightTypes?.length : 0,
		},
	];

	const dataFilteredBySubscription = menuData?.filter((data) => (isStandard ? data?.name !== t("PRIORITY") : true));

	return (
		<PageTemplate classNames="container pt-5" pageTitle={t("TAXONOMY")} maxWidth={1200}>
			<FlexColumnGap gap="16">
				{dataFilteredBySubscription?.map((data, i) => (
					<TaxonomyMenuCard key={i} data={data} />
				))}
			</FlexColumnGap>
		</PageTemplate>
	);
};

Taxonomy.displayName = "Taxonomy";
export default Taxonomy;
